const BackIcon = ({ className }) => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M51.3201 29.6798H8.12007M8.12007 29.6798L24.9201 12.88M8.12007 29.6798L24.9201 46.4798"
        stroke="white"
        strokeWidth="4.32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackIcon;
